interface QA {
  q: string;
  a: React.ReactNode;
}

interface QuickAnswersProps {
  heading?: string;
  items: QA[];
}

/**
 * Above-the-fold "quick answer" block. Answers the most common search
 * questions directly so visitors get value in the first few seconds.
 */
const QuickAnswers = ({ heading = "Quick Answers", items }: QuickAnswersProps) => {
  return (
    <section
      aria-label={heading}
      style={{ background: "#FFFFFF", padding: "40px 0 8px" }}
    >
      <div className="container">
        <h2
          style={{
            color: "#8B1A1A",
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 26,
            margin: "0 0 18px",
          }}
        >
          {heading}
        </h2>
        <div
          style={{
            display: "grid",
            gap: 14,
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          }}
        >
          {items.map((item) => (
            <div
              key={item.q}
              style={{
                background: "#FAF4F0",
                borderLeft: "4px solid #8B1A1A",
                borderRadius: 8,
                padding: "16px 18px",
              }}
            >
              <h3
                style={{
                  color: "#6B1414",
                  fontSize: 16,
                  fontWeight: 700,
                  margin: "0 0 8px",
                }}
              >
                {item.q}
              </h3>
              <p
                style={{
                  color: "#2C2C2C",
                  fontSize: 15,
                  lineHeight: 1.65,
                  margin: 0,
                }}
              >
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickAnswers;
